import parser from './parser';

const filterSet = (tableName, filterList) => {
  let headers = [];
  let filters = [];

  if (filterList) {
    const { 
      /* orderId, */ sinisterNumber, dateFrom, dateTo, state,
      /* companyName, */ rut, invoiceNumber, /* providerCode, */ purchaseOrderId,
    } = filterList;

    switch(tableName) {
      case 'PaymentsAdmin':
        headers = ["Orden", "Nº Fact.", "Proveedor", "Fecha desde", "Fecha hasta", "Estado"];
        filters = [
          purchaseOrderId, 
          invoiceNumber, 
          rut, 
          parser('DATE', dateFrom.toString()), 
          parser('DATE', dateTo.toString()), 
          parser('STATE', state)
        ];
        break;
      case 'OrdersAdmin':
        headers = ["RUT", "Orden", "Siniestro", "Fecha desde", "Fecha hasta"];
        filters = [
          rut, 
          purchaseOrderId, 
          sinisterNumber, 
          parser('DATE', dateFrom.toString()), 
          parser('DATE', dateTo.toString()) 
        ];
        break;
      case 'OrdersUser':
        headers = ["Orden", "Siniestro", "Fecha desde", "Fecha hasta", "Estado"];
        filters = [
          purchaseOrderId, 
          sinisterNumber, 
          parser('DATE', dateFrom.toString()), 
          parser('DATE', dateTo.toString()), 
          parser('STATE', state)
        ];
        break;
      case 'AssociatedInvoices':
        headers = ["Orden", "Nº Fact.", "Fecha desde", "Fecha hasta", "Estado"];
        filters = [
          purchaseOrderId, 
          invoiceNumber, 
          parser('DATE', dateFrom.toString()), 
          parser('DATE', dateTo.toString()), 
          parser('STATE', state)
        ];
        break;
      case 'AccountStatement':
        headers = ["Fecha desde", "Fecha hasta"];
        filters = [
          parser('DATE', dateFrom.toString()), 
          parser('DATE', dateTo.toString()), 
        ];
        break;
      default:
    }
  }
  return {headers, filters};
}

export default filterSet;